import { request } from 'src/api/request';

interface GetDiscoveryProps {
  queryParams: string;
  data?: any;
}

export const getDiscoveryMap = async ({
  queryParams,
  data,
}: GetDiscoveryProps) => {
  return await request({
    url: `v1/search/discovery/map/${queryParams}`,
    method: 'POST',
    data,
    // Idempotent ES read (params in the body) — opt into the 503 retry.
    retryOn503: true,
  });
};

export const getDiscoveryList = async ({
  queryParams,
  data,
}: GetDiscoveryProps) => {
  return await request({
    url: `v1/search/discovery/list/${queryParams}`,
    method: 'POST',
    data,
    // Idempotent ES read (params in the body) — opt into the 503 retry.
    retryOn503: true,
  });
};
